export const routes = [
  {
    path: "/manage",
    name: "home",
    component: () => import("../views/teacher/HomeView.vue"),
    meta: {
      requiresAuth: true,
      role: "teacher",
    },
  },
  {
    path: "/verification",
    name: "verification",
    component: () => import("../views/VerificationView.vue"),
    meta: {
      guest: true,
    },
  },
  {
    path: "/manage/create-schedule",
    name: "createSchedule",
    component: () => import("../views/teacher/CreateScheduleView.vue"),
    meta: {
      requiresAuth: true,
      role: "teacher",
    },
  },
  {
    path: "/manage/edit-schedule/:timetableId",
    name: "editSchedule",
    component: () => import("../views/teacher/EditScheduleView.vue"),
    meta: {
      requiresAuth: true,
      role: "teacher",
    },
  },
  {
    path: "/manage/timetable-weekly/:timetableId",
    name: "timetableWeeklyTeacher",
    component: () => import("../views/teacher/TimetableWeeklyView.vue"),
    meta: {
      requiresAuth: true,
      role: "teacher",
    },
  },
  {
    path: "/view/:qrCode?",
    name: "timetableWeeklyStudent",
    component: () => import("../views/student/TimetableWeeklyView.vue"),
    meta: {
      requiresAuth: true,
      // role: "student",
    },
  },
  {
    path: "/timetable-not-found",
    name: "timetableNotFound",
    component: () => import("../views/TimetableNotFound.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "notFoundPage",
    component: () => import("../views/NotFound.vue"),
    meta: {
      requiresAuth: false,
    },
  },
];
